import { Link } from "Navigation/Link";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import type {
  FunctionComponent,
  PropsWithChildren,
  PropsWithoutRef,
  RefAttributes,
} from "react";
import type { LinkProps } from "react-router-dom";
import styled, { css } from "styled-components";

type Props = PropsWithoutRef<LinkProps> &
  RefAttributes<HTMLAnchorElement> & {
    isWithIcon?: boolean;
  };

const baseLinkStyles = css`
  text-decoration: inherit;
  color: ${(props) => props.theme.palette.primary.main};
  font-weight: 500;
`;

export const StyledHtmlLink = styled.a`
  ${baseLinkStyles}
`;

const StyledLink = styled(Link)`
  ${baseLinkStyles}
`;

const StyledWrapper = styled.div`
  a {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    gap: ${(props) => props.theme.spacing(1)};
  }
`;

export const UnstyledLink: FunctionComponent<PropsWithChildren<Props>> = (
  props,
) => {
  const { isWithIcon, ...rest } = props;

  if (isWithIcon) {
    return (
      <StyledWrapper>
        <StyledLink {...rest}>
          {props.children}
          <ArrowForwardIcon />
        </StyledLink>
      </StyledWrapper>
    );
  }

  return <StyledLink {...rest} />;
};
